import React, { useState, useEffect, useMemo, useRef } from "react";
import { Select, Checkbox } from "antd";

const { Option } = Select;

const SelectComponent = ({
  types = [],
  inputData,
  handleOnChange,
  name,
  defaultAll = false,
}) => {
  const allValues = useMemo(() => types.map((t) => t.value), [types]);

  const [selectedValues, setSelectedValues] = useState(
    defaultAll && allValues.length > 0 ? allValues : (inputData?.[name] || [])
  );

  // Apply "select all" ONCE when types first load (or become non-empty)
  const didAutoSelectRef = useRef(false);
  useEffect(() => {
    if (!defaultAll) return;
    if (didAutoSelectRef.current) return;
    if (allValues.length === 0) return;

    didAutoSelectRef.current = true; // guard first
    setSelectedValues(allValues);
    handleOnChange(allValues);
  }, [defaultAll, allValues, handleOnChange]);

  const handleChange = (values) => {
    setSelectedValues(values);
    handleOnChange(values);
  };

  const isAllSelected = allValues.length > 0 && selectedValues.length === allValues.length;

  return (
    <Select
      mode="multiple"
      maxTagCount="responsive"
      maxTagPlaceholder={(omitted) =>
        `${isAllSelected ? "All Selected" : `+${omitted.length} more`}`
      }
      placeholder={`Select ${name}`}
      value={selectedValues}
      onChange={handleChange}
      style={{ width: "100%" }}
      optionLabelProp="label"
      dropdownRender={(menu) => (
        <>
          <div style={{ padding: 8, borderBottom: "1px solid #f0f0f0", marginLeft: 5 }}>
            <Checkbox
              checked={isAllSelected}
              indeterminate={selectedValues.length > 0 && !isAllSelected}
              onChange={() => {
                if (isAllSelected) {
                  setSelectedValues([]);
                  handleOnChange([]);
                } else {
                  setSelectedValues(allValues);
                  handleOnChange(allValues);
                }
              }}
            >
              Select All
            </Checkbox>
          </div>
          {menu}
        </>
      )}
    >
      {types.map((item) => (
        <Option key={item.value} value={item.value} label={item.label}>
          <Checkbox checked={selectedValues.includes(item.value)}>{item.label}</Checkbox>
        </Option>
      ))}
    </Select>
  );
};

export default SelectComponent;
